import React from "react";
import "../App.css";
import SurveyStatusPage from "../components/question-components/survey-status";

const SecurityTerminate = () => {
  return <SurveyStatusPage status="security_terminated" />;
};

export default SecurityTerminate;
